// getFileTranslation is added for Crowdin integration by seamless
import { getFileTranslation } from '@owc/aem-translations-util';

export const loadTranslations = async (
  language: string,
  country: string,
): Promise<Record<string, string>> => {
  const locale = getLocale(language, country);
  // Crowdin distribution is generated in Crowdin dashboard
  // it should be re generated if a new translation is added
  const distributionHash =
    import.meta.env.VITE_CROWDIN_DISTRIBUTION_ID ||
    'euw1-6f6f62f7263be16403b3ivp';
  const filePath = `/content/${locale}.json`;
  const options = { merge: true };

  const translations = await getFileTranslation(
    filePath,
    distributionHash,
    options,
  );

  if (!translations) {
    throw new Error(`Translations not found for locale: ${locale}`);
  }

  return translations;
};

function getLocale(language: string, country: string) {
  return `${language}-${country}`;
}
